"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SnackbarProvider = _interopRequireDefault(require("@sprinx/react-mui-layout/SnackbarProvider"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    info: {
      background: theme.palette.info.main
    }
  };
});

function SnackbarProvider(_ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_SnackbarProvider.default, {
    classes: {
      info: classes.info
    }
  }, children);
}

process.env.NODE_ENV !== "production" ? SnackbarProvider.propTypes = {
  children: _propTypes.default.node
} : void 0;
SnackbarProvider.defaultProps = {
  children: null
};
var _default = SnackbarProvider;
exports.default = _default;